import {Serializable} from '../deserialize.service';

export class ActionButton implements Serializable<ActionButton> {
    title: string;
    component: any;
    function: string;
    buttonStyle: string;
    disabled: boolean;

    deserialize(input) {
        if (!input || input === null) {
            return null;
        }

        Object.keys(input).forEach((key) => (this[key] = input[key]));

        return this;
    }
}
